import React, { useRef } from 'react'
import { FormikProps } from 'formik'
import classNames from 'classnames'


interface Props <T>{
    formik: FormikProps<T>
    isUpdate : boolean
    onFocus?:()=>void
    disabled?: boolean
    // setValueNumero?: (setValueNumero: string)=> void
    fieldName: keyof T
    infoValue1 ? : string
    infoValue2 ?: string 
    title: string
    widthInput? : string
    className?: string
    valid?: boolean
    padding?: string
    handleVerif?: (val:string)=>void 
    lengthValue?: number
    widthmsgError?: string
    styleValue2?:string
    codeIban?:string
    styleLabel?:string

}


const UpdateInfo = <T,>({ 
    formik, fieldName, isUpdate,  infoValue1,codeIban,
    styleLabel,
    styleValue2=' items-end',
     infoValue2, title, widthInput='w-[170px] lg:w-[150px]', 
     padding, className='h[48px] ', valid=true, onFocus, handleVerif,
     disabled=false ,
     lengthValue,
     widthmsgError
    }: Props<T>) => {

    return (
    <div className={classNames(className,"flex  justify-between  h-14 font-roboto font-medium ")}>
        <div className={classNames(styleLabel,"text-[15px] sm:text-[13px] font-semibold text-[#6B7280] ")}>{title}</div>
        <div className={`${styleValue2} flex flex-col w-full `}>
            <div className={`flex  text-[15px] sm:text-[13px] font-semibold  text-[#35258B]  items-center  gap-1 ${codeIban && 'w-full'} `}>
                {/* <div className=" "> */}
                    

                    {!isUpdate ? <div className=' flex items-start gap-2 '>
                        {infoValue1 ? <span className=''> (+{infoValue1}) </span> : ''}
                        {infoValue2 ? infoValue2 : '_'} </div> 
                    : valid ?
                     
                     <div className='flex flex-col items-start w-full'>
                        <div className={` ${widthInput} flex items-center gap-3 border border-[#AEB6FB]  rounded-[12px] h-[46px] focus:border-[#5754E5] text-[#35258B] pl-3 `}>
                            {codeIban && <div>{codeIban}</div>}
                        {infoValue1  && <div className={`bg-[#F1F1FF] text-[#8F8FCD] rounded-[8px] px-2 h-[28px] justify-center  flex items-center `}> +{infoValue1} </div>}
                            <input className={classNames('outline-none placeholder:font-normal w-full  placeholder:text-[#D1D1FF] `' )}
                                name={String(fieldName)}
                                value={formik.values[fieldName] as string }
                                placeholder={formik.values[fieldName] as string || title }
                                autoComplete="off"
                                onFocus={onFocus}
                                maxLength={lengthValue}
                                
                                // readOnly={readOnly}
                                onChange={ (e)=> {formik.handleChange(e)
                                    handleVerif?.(e.target.value)}}
                                onBlur={formik.handleBlur}
                                disabled={disabled}
                            /> 

                        </div>
                        

                        <span className={classNames (infoValue1 ? padding : '', `text-[9px] lg:text-[7px] text-[#EE443F] items-end  h-[25px]   ${widthmsgError ? widthmsgError : ' w-[170px] lg:w-[150px]' }` )}>
                            {/* {formik.errors[fieldName] as string}  */}
                            {formik.touched[fieldName] && formik.errors[fieldName]
                            ? String(formik.errors[fieldName])
                            : ''}
                            </span>             

                     </div>
                       
                        
                    :
                    '_'
                    }    
            </div>
                   
        </div>
    </div>
  )
}

export default UpdateInfo
